import { CreateComponentSettings } from '../model';
import { Host } from '@wix/bex-utils/@wix/ambassador-app-settings-v1-settings/types';
import { AppSettingsCapsule } from './AppSettingsCapsule';
import { mapGuidComponentIdToNonGuid } from './mapGuidComponentIdToNonGuid';

export const createAppSettingsCapsule: CreateComponentSettings = ({
  httpClient,
  environment,
  queryCache,
}) => {
  return (options) =>
    new AppSettingsCapsule({
      queryCache,
      httpClient,
      context: {
        componentId: mapGuidComponentIdToNonGuid(
          environment.componentId || environment.artifactId,
        ),
        namespace: options.namespace,
        host: Host.BUSINESS_MANAGER,
      },
    });
};
